import API from './api';

const api = new API();

const SECTIONS_DICT = 'api/self/sections';

export default class SectionsAPI {
    async getSectionsDict() {
        const response = await api.getJson(SECTIONS_DICT, {
            method: 'GET',
            credentials: 'include',
        });
        if (response.status !== 0) {
            throw new Error(response.value);
        }
        return response.value;
    }
}
